import { productsAPI } from '../../../services/redwolfSdkAPI';
import useRequestRedwolfService from '../../common/hooks/useRequestRedwolfService';
import * as Sentry from '@sentry/react';

const useGetProductImage = () => {
	const [requestRedwolfService] = useRequestRedwolfService();

	const fetchProductImage = (productIds: any) => {
		const productImages: any = [];

		return requestRedwolfService(productsAPI.getProducts(productIds))
			.then((response: any) => {
				const productDetails = response.data ? response.data.toArray() : [];

				productDetails.forEach((product: any) => {
					const listOfImages: any = [];
					product.images.toArray().forEach((image: any) => {
						listOfImages.push(image.assets.toArray());
					});

					productImages.push({
						id: product.id,
						images: listOfImages.flat()
					});
				});

				return productImages;
			})
			.catch((err: any) => {
				Sentry.captureException(err);
			});
	};

	return [fetchProductImage];
};

export default useGetProductImage;
